import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Homeh/Homeh';
import Formulario from './pages/formulario/Form';
import TermosCondicoes from './pages/termos/TermosCondicoes';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/homeh" element={<Home />} />
        <Route path="/formulario" element={<Formulario />} />
        <Route path="/termos" element={<TermosCondicoes />} />
      </Routes>
    </BrowserRouter>
  );
}